import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'

import Template from '../RegistrationParts/DoubleSelectTemplate'


export default class extends React.Component {
    static propTypes = {
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		sessionUser: PropTypes.object.isRequired
	};

    render() {

		let options = [
			{
				slug: '0-5',
				label: '0 to 5 people'
			},
			{
				slug: '6-10',
				label: '6 to 10 people'
			},
			{
				slug: '11-25',
				label: '11 to 25 people'
			},
			{
				slug: '26-50',
				label: '26 to 50 people'
			},
			{
				slug: '51+',
				label: '51+ people'
			},
		];

		let title = this.props.nowOrGoal === 'now' ? 'How many of you are there?' : 'And how many do you hope to have in three years?';

		let input_name = 'staff',
			user = this.props.sessionUser,
			default_now = user.hasOwnProperty('custom') && user.custom.hasOwnProperty('staff_now') ? user.custom.staff_now : '',
			default_goal = user.hasOwnProperty('custom') && user.custom.hasOwnProperty('staff_goal') ? user.custom.staff_goal : '';

		return (

			<Template 	options={options}
						title={title}
						input_name={input_name}
						nowOrGoal={this.props.nowOrGoal}
						default_now={default_now}
						default_goal={default_goal}
						now_field={input_name + '_now'}
						goal_field={input_name + '_goal'}
						changeData={this.props.changeData}
						prevSlide={this.props.prevSlide}
						nextSlide={this.props.nextSlide} />

		)

	}
}




// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/StaffSlidePart.jsx